<div class="grid">
    <ng-container *ngFor="let row of grid; let i = index">
        <div class="row">
            <button *ngFor="let button of row; let j = index" (click)="onButtonClick(i, j)" [disabled]="!getButtonClickable(i,j)" [ngClass]="getButtonClass(button.type)">
            {{ getButtonText(button) }}
            </button>
        </div>
    </ng-container>
</div>
